module.exports = __webpack_public_path__ + "img/avatar.8e881ccd.jpeg";